/* eslint-disable formatjs/no-literal-string-in-jsx */
import AppBar from "@mui/material/AppBar";
import { Theme, useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";

import { useWidth } from "../../../../shared/hooks/useWidth";
import DesktopMenu from "../DesktopMenu/DesktopMenu";
import MobileMenu from "../MobileMenu/MobileMenu";

type Props = {
  ngProps: {
    farm: { id: string };
  };
  onImpersonationToggle: () => void;
};

const Navbar = ({ ngProps, onImpersonationToggle }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const width = useWidth();

  const LogoLink = (
    <Link className={classes.logoWrapper} to={`/farm/${ngProps.farm.id}`}>
      <img
        alt="logo"
        className={classes.logoImg}
        src={theme.assets.navbar.src}
      />
    </Link>
  );

  return (
    <AppBar
      className={classes.wrapper}
      color="primary"
      elevation={2}
      id="appbar"
      position="fixed"
    >
      {width === "xs" || width === "sm" ? (
        <div className={classes.sectionMobile}>
          {LogoLink}
          <MobileMenu
            ngProps={ngProps}
            onImpersonationToggle={onImpersonationToggle}
          />
        </div>
      ) : (
        <div className={classes.sectionDesktop}>
          {LogoLink}
          <DesktopMenu
            ngProps={ngProps}
            onImpersonationToggle={onImpersonationToggle}
          />
        </div>
      )}
    </AppBar>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  // hack to display navbar correctly with Product Fruits banner
  wrapper: {
    height: 60,
    zIndex: 1030,
    // quick fix, but would be nice to explore the reason, because it is not the first case
    // styles are sometimes overridden, it seems to be related to lazy loading
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    marginLeft: 10,
    marginRight: 5,
    padding: 10,
  },
  logoImg: {
    maxHeight: "100%",
    width: theme.assets.navbar.width,
  },
  sectionDesktop: {
    display: "flex",
    justifyContent: "space-between",
    height: "100%",
    color: "white",
  },
  sectionMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    color: "white",
  },
}));

export { Navbar };
